import { useState, useContext, createContext, useCallback } from "react";

const InvalidateQueryContext = createContext();

export const useInvalidateQuery = () => useContext(InvalidateQueryContext);

export const InvalidateQueryProvider = ({ children }) => {
  const [invalidateKey, setInvalidateKey] = useState(null);

  const triggerInvalidate = useCallback((key) => {
    setInvalidateKey(key);
  }, []);

  const resetKey = useCallback(() => {
    setInvalidateKey(null);
  }, []);

  return (
    <InvalidateQueryContext.Provider
      value={{ invalidateKey, triggerInvalidate, resetKey }}
    >
      {children}
    </InvalidateQueryContext.Provider>
  );
};
